import { useEffect, useRef } from 'react';
import { useRouter } from 'shared-routing';

import { BookingEntity, canonicalBookingStep } from '@common/helpers/bookingSteps';

type CanonicalBookingStepOptions = {
  entity: BookingEntity;
  bookingRoute: string;
  detailRoute: string;
  id: string | number;
};

export const useCanonicalBookingStep = (
  bookingStep: string | string[] | undefined,
  { entity, bookingRoute, detailRoute, id }: CanonicalBookingStepOptions
): string | undefined => {
  const router = useRouter();
  const hasRedirected = useRef(false);

  const raw = Array.isArray(bookingStep) ? bookingStep[0] : bookingStep;
  const canonical = canonicalBookingStep(raw, entity);
  const needsRedirect = !!raw && raw !== canonical;

  useEffect(() => {
    if (!needsRedirect || hasRedirected.current) return;

    hasRedirected.current = true;
    // router.query is cloned every render, so tracking it would cancel this navigation.
    const { bookingStep: _step, ...rest } = router.query;
    router.replace({
      pathname: canonical ? bookingRoute : detailRoute,
      query: canonical ? { ...rest, id, bookingStep: canonical } : { ...rest, id },
    });
  }, [needsRedirect, canonical, bookingRoute, detailRoute, id]);

  return canonical;
};
